import { render, staticRenderFns } from "./cardInTab.vue?vue&type=template&id=1f72e582&scoped=true&"
import script from "./cardInTab.vue?vue&type=script&lang=js&"
export * from "./cardInTab.vue?vue&type=script&lang=js&"
import style0 from "./cardInTab.vue?vue&type=style&index=0&id=1f72e582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72e582",
  null
  
)

component.options.__file = "cardInTab.vue"
export default component.exports